module.exports = __webpack_public_path__ + "static/pallo_siluetti.478e4869.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pallo_siluetti.svg
// module id = 95
// module chunks = 35783957827783 114276838955818